<template>
  <div class="d-inline-flex ma-1">
    <template v-if="anchor">
      <a @click="showModal">Void</a>
    </template>
    <template v-else>
      <v-btn class="ma-0 pa-0" color="error" outline small @click="showModal"><v-icon small class="mr-1" style="color: var(--v-error-darken1) !important;">cancel</v-icon>Void</v-btn>
    </template>

    <v-dialog v-model="enabled" max-width="800px" @keydown.esc.prevent="enabled = false">
      <v-toolbar dense>
        <v-toolbar-title>Void</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="primary" @click.native="enabled = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <VoidPanel :transaction="transaction"></VoidPanel>
    </v-dialog>
  </div>
</template>

<script>
import Bus from '@/bus'

import VoidPanel from './Void.vue'

export default {
  components: {VoidPanel},

  data: function () {
    return {
      enabled: false
    }
  },

  props: {
    transaction: Object,
    anchor: Boolean
  },

  beforeDestroy () {
    Bus.$off('closeOptionsModal')
  },

  mounted () {
    Bus.$on('closeOptionsModal', this.closeModal)
  },

  methods: {
    showModal () {
      this.enabled = true
    },
    closeModal () {
      this.enabled = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/VoidModal.vue